// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userBar{background-color:#3c4349;color:#fff;display:flex;align-items:center;font-size:14px;height:36px;justify-content:space-between;padding:0 25px;position:fixed;top:70px;z-index:2;width:100%}.userBar>span{text-align:center;justify-self:center;margin:0 auto}.userBar>div{display:flex}", ""]);
// Exports
module.exports = exports;
